import { AsyncState, unloadedAsyncState, Option } from "widgets-for-react"

export type RedirectResult = {
  OriginalSlug: string,
  NewSlug: string,
  Permanent: boolean,
  Id: string,
  SharepointId: number,
}

export type RedirectState = {
  redirect: AsyncState<Option<RedirectResult>>
}

export const initialRedirectState : () => RedirectState = () => ({
  redirect: unloadedAsyncState()
})